require("!!C:\\Users\\Pedro\\1-KRAFTI\\MMEGA\\PAINEL\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\Pedro\\1-KRAFTI\\MMEGA\\PAINEL\\node_modules\\raw-loader\\index.js!C:\\Users\\Pedro\\1-KRAFTI\\MMEGA\\PAINEL\\node_modules\\bootstrap-tagsinput\\dist\\bootstrap-tagsinput.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap-tagsinput/dist/bootstrap-tagsinput.js
// module id = 343
// module chunks = 16